export default "__VITE_ASSET__BvRnUCdo__"